import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgColorPicker32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#7149E7"
          d="M10.869 14.82a5.249 5.249 0 0 1 .665-1.618.343.343 0 0 0-.042-.43l-5.78-5.78a.359.359 0 0 0-.525.02 13.988 13.988 0 0 0-3.185 7.695.36.36 0 0 0 .357.388h8.174c.164 0 .3-.116.336-.276"
        />
        <path
          fill="#AE40C9"
          d="M15.095 10.533V2.36a.36.36 0 0 0-.388-.358 13.99 13.99 0 0 0-7.694 3.186.358.358 0 0 0-.02.526l5.778 5.778c.117.116.293.13.431.044a5.2 5.2 0 0 1 1.618-.666.347.347 0 0 0 .275-.336"
        />
        <path
          fill="#EF3F3F"
          d="M24.988 5.187A13.996 13.996 0 0 0 17.293 2a.36.36 0 0 0-.388.358v8.174c0 .164.116.3.276.336a5.229 5.229 0 0 1 1.617.665.343.343 0 0 0 .431-.043l5.779-5.778a.358.358 0 0 0-.02-.526"
        />
        <path
          fill="#4464EA"
          d="M11.535 18.798a5.2 5.2 0 0 1-.666-1.618.347.347 0 0 0-.336-.275H2.36a.36.36 0 0 0-.358.388 13.99 13.99 0 0 0 3.186 7.695c.133.16.38.166.526.02l5.778-5.779a.346.346 0 0 0 .044-.431"
        />
        <path
          fill="#F49F02"
          d="M21.131 14.82c.037.16.172.275.336.275h8.174a.36.36 0 0 0 .358-.388 13.99 13.99 0 0 0-3.186-7.695.358.358 0 0 0-.526-.02l-5.778 5.779a.345.345 0 0 0-.043.43 5.2 5.2 0 0 1 .665 1.618z"
        />
        <path
          fill="#FBC41D"
          d="M20.466 18.798a.343.343 0 0 0 .042.43l5.78 5.78a.359.359 0 0 0 .525-.02 13.988 13.988 0 0 0 3.185-7.695.36.36 0 0 0-.357-.388h-8.174c-.164 0-.3.116-.336.276a5.249 5.249 0 0 1-.665 1.617z"
        />
        <path
          fill="#75B818"
          d="M18.798 20.465a5.2 5.2 0 0 1-1.617.666.347.347 0 0 0-.276.336v8.174a.36.36 0 0 0 .388.358 13.99 13.99 0 0 0 7.695-3.186.358.358 0 0 0 .02-.526l-5.779-5.778a.345.345 0 0 0-.43-.044"
        />
        <path
          fill="#38B14E"
          d="M13.202 20.466a.343.343 0 0 0-.43.042l-5.78 5.78a.359.359 0 0 0 .02.525 13.988 13.988 0 0 0 7.695 3.185.36.36 0 0 0 .388-.357v-8.174c0-.164-.116-.3-.276-.336a5.249 5.249 0 0 1-1.617-.665z"
        />
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgColorPicker32);
export default Memo;
